"use strict";

define('view/submission/submission.detail',['require','exports','module','underscore','marionette','backbone','handlebars','config','controller/meeting/submission','uikit/uikit','libs/color','libs/format/date','libs/format/empty','libs/format/list','collection/base','model/assignment','model/assignment.type','service/assignment','model/board','model/person','model/document','model/checklist','./submission.approvals.tab','view/attachments.tab','view/page.list','view/table.ellipsis','view/assign.review.type.overlay','view/assign.reviewer.overlay','templates','langs'],function (require, exports, module) {
  var _ = require('underscore'),
    Mn = require('marionette'),
    Backbone = require('backbone'),
    Handlebars = require('handlebars'),
    config = require('config'),
    MeetingSubmissionController = require('controller/meeting/submission'),
    UIKit = require('uikit/uikit'),
    Color = require('libs/color'),
    dateFormatter = require('libs/format/date'),
    emptyFormatter = require('libs/format/empty'),
    listFormatter = require('libs/format/list'),
    BaseCollection = require('collection/base'),
    AssignmentModel = require('model/assignment'),
    AssignmentTypeModel = require('model/assignment.type'),
    AssignmentService = require('service/assignment'),
    BoardModel = require('model/board'),
    PersonModel = require('model/person'),
    DocumentModel = require('model/document'),
    ChecklistModel = require('model/checklist'),
    SubmissionApprovalsTab = require('./submission.approvals.tab'),
    AttachmentsTab = require('view/attachments.tab'),
    PageListView = require('view/page.list'),
    TableEllipsis = require('view/table.ellipsis'),
    AssignReviewTypeOverlay = require('view/assign.review.type.overlay'),
    AssignReviewerOverlay = require('view/assign.reviewer.overlay'),
    Templates = require('templates'),
    L10N = require('langs');
  var linkTextFormatter = function linkTextFormatter(v) {
    return new Handlebars.SafeString('<span tabindex="0" role="button" class="link">' + v + '</span>');
  };
  var TASKS_HISTORY_COLUMNS = [{
    text: 'Name',
    data: 'person.displayName'
  }, {
    text: 'Role',
    data: 'assignment'
  }, {
    text: 'Routing Action',
    data: 'action'
  }, {
    text: 'Completion Date',
    data: 'taskEndDate',
    formatter: dateFormatter('L LT')
  }];
  var DECISION_HISTORY_COLUMNS = [{
    text: 'Decision Outcome',
    data: 'decisionType.description',
    formatter: linkTextFormatter
  }, {
    text: 'Result Date',
    data: 'resultDate',
    formatter: dateFormatter(config.dateFormat)
  }];
  var LETTERS_COLUMNS = [{
    text: 'Subject',
    data: 'subject',
    formatter: linkTextFormatter
  }, {
    text: 'Recipients',
    data: 'recipients',
    formatter: listFormatter()
  }, {
    text: 'Sent Date',
    data: 'dateSent',
    formatter: dateFormatter(config.dateFormat)
  }];
  var MEETINGS_COLUMNS = [{
    text: 'Location',
    data: 'location',
    formatter: linkTextFormatter
  }, {
    text: 'Date',
    data: 'startDate',
    formatter: dateFormatter('L LT')
  }];
  var TaskDropdownView = UIKit.Dropdown.extend({
    className: UIKit.Dropdown.prototype.className + ' ',
    options: _.extend({}, UIKit.Dropdown.prototype.options, {
      search: true
    }),
    bindings: {
      text: 'displayName',
      completed: 'completed'
    },
    events: _.extend({}, UIKit.Dropdown.prototype.events, {
      'blur > input.search': 'delaySwitchToItemView',
      'focus > input.search': 'switchToDropdownView'
    }),
    switchToDropdownView: function switchToDropdownView() {
      this.$el.removeClass('item').addClass('focused');
      this.$el.css({
        'margin-left': '-1em',
        'margin-top': '-1em',
        'padding-left': '0.6929em',
        'border-color': this._dropdownBorder
      });
      this.$el.find('i.icon').css({
        display: 'inline-block'
      });
      this.$el.find('> .text').css({
        'text-decoration': 'none'
      });
    },
    delaySwitchToItemView: function delaySwitchToItemView() {
      var self = this;
      setTimeout(function () {
        self.switchToItemView();
      }, 200);
    },
    switchToItemView: function switchToItemView() {
      this.$el.addClass('item').removeClass('focused');
      this.$el.css({
        'padding-left': 0,
        'border-color': 'transparent',
        'margin-left': '0em',
        'margin-top': '0em'
      });
      this.$el.find('i.icon').css({
        display: 'none'
      });
      if (this.model.get('completed')) {
        this.$el.find('> .text').css({
          'text-decoration': 'line-through'
        });
      } else {
        this.$el.find('> .text').css({
          'text-decoration': 'none'
        });
      }
    },
    onFirstRender: function onFirstRender() {
      this._dropdownBorder = this.$el.css('border-color');
      UIKit.Dropdown.prototype.onFirstRender.apply(this, arguments);
    },
    updateAttributes: function updateAttributes() {
      UIKit.Dropdown.prototype.updateAttributes.apply(this, arguments);
      this.$el.css({
        transition: 'border 0s'
      });
      this.addClass('completed', this.getBoolOption('completed'));
      this.$('> .text').css({
        color: '#009fda',
        cursor: 'pointer'
      });
      this.switchToItemView();
    }
  });
  var TaskView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    tagName: 'div',
    className: 'item',
    attributes: {
      role: 'menuitem'
    },
    template: function template(data) {
      return '<div class="content"><a class="description">' + data.model.displayName + '</a></div>';
    },
    events: {
      'keydown .description': function keydown_Description(ev) {
        if (ev.keyCode === 13) {
          this.trigger('press');
        }
      }
    },
    triggers: {
      'click .content': 'press'
    },
    onRender: function onRender() {
      this.$el.find('.description').prop('tabindex', 0);
    },
    updateAttributes: function updateAttributes() {
      this.$el.find('.content').css({
        display: 'inline-block'
      });
      this.addClass('completed', this.model.get('completed'));
      if (this.model.get('completed')) {
        this.$el.find('.content').css({
          'text-decoration': 'line-through'
        });
      } else {
        this.$el.find('.content').css({
          'text-decoration': 'none'
        });
      }
    }
  });
  var ListView = Mn.CollectionView.extend(UIKit.ComponentMixin).extend({
    className: 'ui bulleted list details-list-noglyph',
    childView: TaskView,
    getChildView: function getChildView(task) {
      if (task.get('action') === 'assignAnalyst') {
        return TaskDropdownView;
      } else {
        return TaskView;
      }
    }
  });
  var SubmissionDetailView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['submission.detail'],
    options: {
      app: null,
      study: null,
      analysts: null,
      assignments: null,
      studyAssignments: null,
      permissions: null,
      commonRuleOptions: null,
      approvals: null,
      decisions: null,
      openDecisions: null,
      letters: null,
      meetings: null,
      tasks: null,
      tasksHistory: null,
      checklists: null,
      historicalChecklists: null,
      decisionDigestTable: null,
      decisionHistoryTable: null,
      lettersTable: null,
      taskHistoryTable: null,
      allowApplyStamps: false,
      useSubmissionDetailsHeader: false,
      hideSubmissionDetailsHeaderFromScreens: true,
      submissionDetailsHeaderText: ''
    },
    update: {
      app: false,
      analysts: false,
      study: false,
      assignments: false,
      studyAssignments: false,
      permissions: false,
      commonRuleOptions: false,
      approvals: false,
      decisions: false,
      openDecisions: false,
      letters: false,
      meetings: false,
      tasks: false,
      tasksHistory: false,
      checklists: false,
      historicalChecklists: false,
      decisionDigestTable: false,
      decisionHistoryTable: false,
      lettersTable: false,
      taskHistoryTable: false,
      allowApplyStamps: false,
      submissionDetailsHeaderText: true
    },
    modelEvents: {
      allFetched: 'refreshModelDetails'
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this._requiredTasks = new BaseCollection();
      this.checklistDropdownCollection = new BaseCollection();
      this.setupForm();
      this.setupTables();
      this.setupTabs();
      this._setupEditableFieldListeners();
      this.createActionButtons();
    },
    refreshModelDetails: function refreshModelDetails() {
      this._refreshPageAssignments();
      this._refreshPageTasks();
      this._refreshFormText();
      this._refreshFormEditability();
      this._refreshActionBtns();
      this._refreshWorkflowProgression();
      this._refreshChildDecisions();
      this._refreshFinalizedState();
      this._refreshTabsVisibility();
      this._refreshPdfList();
      this.trigger('refreshComplete');
    },
    findTabByMenuText: function findTabByMenuText(text) {
      var tabs = this.tabs,
        menu = tabs.menu;
      for (var t = 0, len = menu._views.length; t < len; t++) {
        if (menu.at(t).text === text) {
          return tabs.at(t);
        }
      }
    },
    _refreshTabsVisibility: function _refreshTabsVisibility() {
      var tabs = this.tabs,
        menu = this.tabs.menu,
        approvalsTab = this.findTabByMenuText('Approvals'),
        taskHistoryTab = this.findTabByMenuText('Task History'),
        lettersTab = this.findTabByMenuText('Letters'),
        meetingsTab = this.findTabByMenuText('Meetings'),
        decisionsTab = this.findTabByMenuText('Decisions'),
        attachmentsTab = this.findTabByMenuText('Attachments');
      lettersTab.menuItem.visible = !!this.letters.length;
      meetingsTab.menuItem.visible = !!this.meetings.length;
      decisionsTab.menuItem.visible = !!this.decisionDigestTable.collection.length || !!this.decisions.length;
      if (!menu.at(tabs.openTabIndex).visible) {
        tabs.open(0);
      }
    },
    _refreshFinalizedState: function _refreshFinalizedState() {
      var tabs = this.tabs,
        decisionsLen = this.decisionHistoryTable.collection.length,
        childDecisionsLen = this.decisionDigestTable.collection.length,
        submissionForm = this.submissionForm,
        meetingDate = submissionForm.meetingDate,
        tasksContainer = submissionForm.taskContainer,
        finalizedDate = this.model.get('finalizedDate'),
        decisionsTab = this.findTabByMenuText('Decisions'),
        status = this.model.get('status');
      templateType = this.model.get('templateType');
      decisionsTab.content.at(1).visible = !!childDecisionsLen || !finalizedDate;
      decisionsTab.content.at(2).visible = !!childDecisionsLen || !finalizedDate;
      decisionsTab.content.at(3).visible = !!decisionsLen;
      decisionsTab.content.at(4).visible = !!decisionsLen;
      if (templateType !== 'Legacy' && templateType !== 'Withdrawal' && templateType !== 'Admin Closure' && templateType !== 'Closure' && templateType !== 'Admin Withdrawal') {
        this.allowApplyStamps = 'Review Complete' === status;
      } else {
        this.allowApplyStamps = false;
      }
      if (finalizedDate) {
        meetingDate.getOption('parent').visible = false;
        tasksContainer.getOption('parent').visible = false;
        tasksContainer.getOption('parent').getOption('parent').at(0).width = 16;
        tabs.open(0);
        tabs.at(3).menuItem.visible = false;
        decisionsTab.menuItem.visible = false;
      }
    },
    _refreshFormEditability: function _refreshFormEditability() {
      this.policyField.editable = this.app.user.person.hasPermission('IRB_MODIFY_STUDY_POLICY') && this.model.get('status').toLowerCase() === 'under pre-review';
    },
    _refreshFormText: function _refreshFormText() {
      var meeting = null,
        now = new Date().getTime(),
        meetingDate = '',
        viewMeetingPerm = this.hasViewMeetingPermission(),
        submissionService = this.app.service('submission');
      meeting = this.meetings.find(function (m) {
        return m.get('startDate') > now;
      });
      if (!meeting) {
        meeting = this.meetings.last();
      }
      meetingDate = meeting ? dateFormatter('L')(meeting.get('startDate')) : '';
      this.studyTitleText.text = this.study.get('label') + ' - ' + this.study.get('title');
      this.statusLabel.color = Color.Status(this.model.get('status'));
      this.submissionForm.meetingDate.text = meetingDate;
      this.submissionForm.meetingDate.link = submissionService.getMeetingDetailLink(meeting, this.model);
      this.submissionForm.meetingDateText.text = meetingDate;
      if (viewMeetingPerm) {
        this.submissionForm.meetingDate.visible = !!meetingDate;
        this.submissionForm.meetingDateText.visible = !meetingDate;
      } else {
        this.submissionForm.meetingDate.visible = false;
        this.submissionForm.meetingDateText.visible = true;
      }
      var meetingColumns = MEETINGS_COLUMNS.slice(0);
      var self = this;
      if (viewMeetingPerm) {
        this.meetingsTable.rowLinkFormatter = function (meeting) {
          return submissionService.getMeetingDetailLink(meeting, self.model);
        };
      } else {
        delete meetingColumns[0].formatter;
      }
      this.meetingsTable.columns.reset(meetingColumns);
      this.meetingsTable.selectable = viewMeetingPerm;
    },
    _refreshPageAssignments: function _refreshPageAssignments() {
      if (this.isRendered) {
        var analyst = this.assignments.getByAssignmentTypeProp('IRB_ANALYST', 'description').models[0],
          pi = this.assignments.getByAssignmentTypeProp('PRINCIPAL_INVESTIGATOR', 'description').models[0],
          reviewBoard = this.assignments.getByAssignmentTypeProp('IRB_BOARD', 'description').models[0],
          reviewType = this.assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0],
          submissionForm = this.submissionForm;
        if (analyst) {
          this.analystField.model = analyst;
        }
        if (pi) {
          submissionForm.pi.text = pi.get('person').get('displayName');
        }
        submissionForm.reviewBoard.text = reviewBoard ? reviewBoard.get('group').get('name') : null;
        submissionForm.reviewType.text = null;
        if (reviewType) {
          var matchingReviewTypes = AssignmentService.ReviewTypes.filter(function (rType) {
            return rType.value === reviewType.get('value');
          });
          if (!_.isEmpty(matchingReviewTypes)) {
            submissionForm.reviewType.text = _.first(matchingReviewTypes).description;
          }
        }
        var analystSelected = this.tasks.find(function (task) {
          return task.get('taskType').taskName == 'IRB_ANALYST_SELECTED';
        });
        this.analystField.editable = analyst && !analystSelected && !this.model.get('finalizedDate') && this.app.user.person.hasPermission('IRB_CHANGE_ANALYST');
      }
    },
    _refreshPageTasks: function _refreshPageTasks() {
      var currentTask = this.getCurrentTask(),
        requiredTasks = null,
        templateType = this.model.get('templateType');
      if (this.isRendered) {
        if (currentTask) {
          requiredTasks = app.service('workflow').getRequiredTasks(currentTask).models;
          if (templateType !== 'Initial' && templateType !== 'Modification') {
            requiredTasks = requiredTasks.filter(function (task) {
              return task.get('action') !== 'assignPrincipalInvestigator' && task.get('action') !== 'assignPrimaryContact';
            });
          }
          for (var r = 0, len = requiredTasks.length; r < len; r++) {
            requiredTasks[r].set('completed', this.isTaskCompleted(requiredTasks[r]));
          }
          this._requiredTasks.reset(requiredTasks);
        } else {
          this._requiredTasks.reset([]);
        }
        this.submissionForm.taskContainer.visible = !!this._requiredTasks.length;
        this.submissionForm.emptyRequiredTasks.visible = !this._requiredTasks.length;
      }
    },
    _refreshActionBtns: function _refreshActionBtns() {
      var permissions = this.permissions.models[0],
        currentTask = this.getCurrentTask(),
        answers = null;
      var setAriaLabel = function setAriaLabel(formNavBtnView) {
        var ariaLabelPrefix = permissions.get('canWrite') ? L10N.phrase('Submissions.Button.Edit.ARIALabel.Prefix') : permissions.get('canWriteComments') ? L10N.phrase('Submissions.Button.Review.ARIALabel.Prefix') : L10N.phrase('Submissions.Button.View.ARIALabel.Prefix');
        var ariaLabelSuffix = L10N.phrase('Submissions.Button.ViewEditReview.ARIALabel.Suffix');
        formNavBtnView.$el.attr('aria-label', ariaLabelPrefix + ariaLabelSuffix);
      };
      this.formNavBtn.disabled = !permissions.get('canRead');
      this.formNavBtn.text = 'View';
      this.formNavBtn.icon = 'eye';
      if (permissions.get('canWrite')) {
        this.formNavBtn.text = 'Edit';
        this.formNavBtn.icon = 'pencil';
      } else if (permissions.get('canWriteComments')) {
        this.formNavBtn.text = 'Review';
        this.formNavBtn.icon = 'file text';
      }
      setAriaLabel(this.formNavBtn);
      this.deleteBtn.disabled = !!this.model.get('lastReadOnlyDate') || !permissions.get('canWrite');
      this.checklistBtn.visible = this.hasAvailableChecklists();
      this.createRoutingButtons(permissions);
    },
    _setupEditableFieldListeners: function _setupEditableFieldListeners() {
      this.listenTo(this.analystField, 'confirm', function () {
        this.analystField.confirmButton.loading = true;
        app.service('workflow').requestChangeAnalyst(this.model, this.analystField.model.get('person')).bind(this).tap(function () {
          this.analystField.editing = false;
        })["finally"](function () {
          this.analystField.confirmButton.loading = false;
        });
      }).listenTo(this.policyField, 'confirm', function () {
        this.submissionForm.clearErrors();
        var selectedValue = this.policyField.input.collection.findWhere({
          description: this.policyField.model.get('value')
        });
        app.service('submission').requestChangePolicy(this.model, selectedValue).bind(this).tap(function () {
          this.policyField.editing = false;
        });
      }).listenTo(this.policyField, 'close', function () {
        var policyField = this.policyField;
        var previousPolicy;
        this.submissionForm.clearErrors();
        if (policyField.originalPolicy !== this.model.get('commonRulePolicy')) {
          previousPolicy = policyField.input.collection.findWhere({
            name: policyField.originalPolicy
          });
          policyField.input.value = previousPolicy;
        }
      });
      this.policyField.on('after:render:all', function () {
        this.setPolicyField();
      }).on('childview:item:select', function (dropdownView, selectedView, value) {
        var submissionModel = this.getOption('submissionModel');
        if (submissionModel.get('commonRulePolicy') !== value.get('name')) {
          submissionModel.set({
            'commonRulePolicy': value.get('name')
          });
        }
        this.textView.text = value.get('description');
      });
    },
    hasAvailableChecklists: function hasAvailableChecklists() {
      return !_.isEmpty(this.checklists.models) || this.model.get('finalizedDate') && !_.isEmpty(this.historicalChecklists.models);
    },
    getCurrentTask: function getCurrentTask() {
      return _.find(this.tasks.models || [], function (m) {
        return !m.get('taskType').passive;
      });
    },
    getDecisionBasedAnswer: function getDecisionBasedAnswer(answer, task) {
      var openDecision = this.openDecisions.models[0];
      if (openDecision && answer.get('value') === 'YES') {
        switch (task.get('taskType').taskName) {
          case 'IRB_EXEMPT_REVIEW_COMPLETE':
          case 'EXPEDITED_REVIEW_COMPLETE':
          case 'ADMINISTRATIVE_REVIEW_COMPLETE':
          case 'LIMITED_IRB_REVIEW_COMPLETE':
            switch (openDecision.get('decisionType.description')) {
              case 'Not Exempt':
              case 'Not Expedited':
              case 'Not Limited IRB':
                answer.set('shortName', 'Re-Assign');
                answer.set('name', 'Re-Assign');
            }
            break;
        }
      }
      return answer;
    },
    createRoutingButtons: function createRoutingButtons(permissions) {
      var container = this.buttonGroup,
        currentTask = this.getCurrentTask(),
        answers = [],
        answer = null;
      container.empty();
      if (currentTask) {
        answers = this.getFilteredTaskAnswers();
        var specificAnswers = answers.filter(function (a) {
          return a.get('value') === 'BOARD' || a.get('value') === 'REVIEWER';
        });
        if (specificAnswers.length) {
          var routingDropdown = new UIKit.Dropdown({
            text: 'Change',
            color: 'secondary',
            collection: new BaseCollection(specificAnswers),
            childBindings: {
              text: 'shortName'
            },
            floating: true,
            mode: 'button',
            pointing: 'top right'
          });
        }
        for (var i = 0, numOfAnswers = answers.length; i < numOfAnswers; i++) {
          answer = this.getDecisionBasedAnswer(answers.models[i], currentTask);
          if (answer.get('value') === 'BOARD' || answer.get('value') === 'REVIEWER') {
            container.add(routingDropdown);
            continue;
          }
          var routingBtn = this.createRoutingButton(answer);
          container.add(routingBtn, {
            destroyOnRemove: true
          });
        }
      }
    },
    createRoutingButton: function createRoutingButton(answer) {
      var hoverContent = new UIKit.Text({
          model: answer,
          bindings: {
            text: 'name'
          }
        }),
        hoverPopup = new UIKit.Popup({
          size: 'small',
          content: hoverContent,
          inverted: true
        }),
        routingBtn = new UIKit.Button({
          model: answer,
          bindings: {
            text: 'shortName'
          },
          color: 'secondary'
        });
      hoverPopup.attach(routingBtn);
      (function (btn, p) {
        btn.on('press', function () {
          p.visible = false;
        }).on('destroy', function () {
          p.destroy();
        });
      })(routingBtn, hoverPopup);
      return routingBtn;
    },
    getFilteredTaskAnswers: function getFilteredTaskAnswers() {
      var currentTask = this.getCurrentTask(),
        answers = app.service('workflow').getAnswers(currentTask);
      if (currentTask.get('taskType').taskName === 'IRB_FULL_REVIEW_COMPLETE') {
        var openDecision = this.openDecisions.at(0);
        if (openDecision && openDecision.get('decisionType') || this.hasOpenLetters()) {
          answers = new BaseCollection(answers.filter(function (a) {
            return a.get('value') === 'YES';
          }));
        }
      }
      return answers;
    },
    createActionButtons: function createActionButtons() {
      var app = this.app,
        toolsContainer = new UIKit.Container(),
        fieldGroup = null,
        routingField = null,
        self = this,
        submissionService = app.service('submission');
      var pdfBtn = new UIKit.Dropdown({
        text: 'PDF',
        collection: this.checklistDropdownCollection,
        compact: true,
        mode: UIKit.Dropdown.BUTTON_MODE,
        attributes: {
          role: 'button',
          'aria-label': L10N.phrase('Submissions.Button.PDF.ARIALabel')
        },
        childBindings: {
          text: 'text',
          link: 'link',
          target: 'target',
          icon: 'icon'
        }
      }).on('render', function () {
        var $container = this.getChildViewContainer(this);
        $container.css({
          'max-height': '300px',
          overflow: 'auto'
        });
      });
      this.listenTo(pdfBtn, 'press', function (model) {
        if (model.get('type') === 'submission') {
          submissionService.createPDF(this.study, this.model, this.app);
        }
      });
      this.formNavBtn = new UIKit.Button({
        text: 'View',
        icon: 'eye',
        disabled: true,
        attributes: {
          role: 'button'
        }
      });
      this.listenTo(this.formNavBtn, 'press', function () {
        submissionService.navigateToFormViewer(this.model);
      });
      this.deleteBtn = new UIKit.Button({
        text: 'Delete',
        icon: 'trash',
        disabled: true,
        attributes: {
          role: 'button',
          'aria-label': L10N.phrase('Submissions.Button.Delete.ARIALabel')
        }
      });
      this.listenTo(this.deleteBtn, 'press', function () {
        app.request('modal', {
          type: 'CONFIRM_DESTROY',
          state: this.state,
          name: this.model.get('templateType') + ' Submission'
        }, {
          ariaControlsId: 'submissionDetails'
        }).on('destroy:model', function () {
          self.model.destroy({
            wait: true
          }).promise()["finally"](app.request('dimmer'));
        });
      });
      this.checklistBtn = new UIKit.Button({
        text: 'Checklist',
        icon: 'list',
        attributes: {
          role: 'button',
          'aria-label': L10N.phrase('Submissions.Button.Checklist.ARIALabel')
        }
      });
      this.listenTo(this.checklistBtn, 'press', function () {
        submissionService.navigateAndOpenChecklists(this.app, this.model);
      });
      this.buttonGroup = new UIKit.Container().on('add remove', function () {
        if (this.buttonGroup.isEmpty()) {
          routingField.visible = false;
        } else {
          routingField.visible = true;
        }
      }, this);
      this.listenTo(this.buttonGroup, 'childview:press', _.debounce(function (routingItemView, model) {
        if (routingItemView instanceof UIKit.Dropdown) {
          self.handleWorkflowRouting(model);
        } else {
          self.handleWorkflowRouting(routingItemView.model);
        }
      }), null, true);
      fieldGroup = this.actions.addGroup({
        size: -1
      });
      fieldGroup.addField({}, toolsContainer);
      routingField = fieldGroup.addField({
        text: 'Routing:',
        floated: 'right'
      }, this.buttonGroup);
      routingField.visible = false;
      routingField.$el.addClass('workflow routing').css('margin-bottom', '1em').css('margin-top', '-1.5em');
      toolsContainer.add(this.formNavBtn);
      toolsContainer.add(pdfBtn);
      toolsContainer.add(this.deleteBtn);
      toolsContainer.add(this.checklistBtn);
    },
    showModal: function showModal(answer, task, confirmMsg, headerTxt) {
      return this.app.request('modal', {
        approveBtn: answer.get('approveBtn'),
        denyBtn: answer.get('denyBtn') || {
          inverted: false
        },
        content: confirmMsg,
        icon: answer.get('icon'),
        header: headerTxt,
        type: 'CONFIRM'
      }, {
        basic: answer.get('basicModal') || false
      }).on('modal:visible', function (e) {
        var self = this;
        setTimeout(function () {
          $(self.el).find('.ok').focus();
        }, 500);
      }).on('confirm', function () {
        this.requestWorkflowSetAnswer(answer, task);
      }, this);
    },
    handleWorkflowRouting: function handleWorkflowRouting(answer) {
      var task = this.getCurrentTask(),
        MessageTemplate = app.model('MessageTemplate');
      if (answer.get('confirmTemplateCode') && !answer.has('confirm')) {
        return new MessageTemplate().set('code.name', answer.get('confirmTemplateCode')).set('templateType.name', answer.get('confirmTemplateType') || 'Notification').once('sync', function (model) {
          model.preview({
            ownerId: this.model.id
          }).promise()["finally"](app.request('dimmer'));
        }, this).once('preview', function (email) {
          answer.set('confirm', new Handlebars.SafeString(email.get('content')));
          this.handleWorkflowRouting(answer);
        }, this).fetch().promise()["finally"](app.request('dimmer'));
      }
      var confirmMsg = answer.get('confirm') || 'Are you sure you want to continue?',
        headerTxt = answer.get('name');
      if (task.get('taskType').taskName === 'IRB_ANALYST_ASSIGN_REVIEWERS' && answer.get('value') === 'YES') {
        if (this.isFullBoardReview() && !this.validateDocumentReviewerAssignments()) {
          confirmMsg = 'Are you sure you would like to continue without assigning a primary or secondary reviewer?';
        }
      }
      var study = this.options.study;
      var theDecision = this.getResponsibleDecision(this.useParentDecision());
      var self = this;
      var modal;
      var reviewTasks = ['EXPEDITED_REVIEW_COMPLETE', 'IRB_FULL_REVIEW_COMPLETE', 'IRB_MEMBER_EXPEDITED_REVIEW', 'IRB_EXEMPT_REVIEW_COMPLETE', 'IRB_EXEMPT_POST_REVIEW', 'IRB_EXPEDITED_PRIMARY_REVIEW', 'IRB_FULL_EXPEDITED_REVIEW', 'IRB_FULL_EXPEDITED_POST_REVIEW', 'IRB_REVIEW', 'LIMITED_IRB_PRIMARY_REVIEW', 'LIMITED_IRB_MEMBER_REVIEW', 'LIMITED_IRB_REVIEW_COMPLETE', 'ADMINISTRATIVE_PRIMARY_REVIEW', 'IRB_MEMBER_ADMINISTRATIVE_REVIEW', 'ADMINISTRATIVE_REVIEW_COMPLETE'];
      if (reviewTasks.includes(task.get('taskType').taskName) && answer.attributes.value === 'YES' && theDecision && (theDecision.isAdminCheckInDateUpdated(study.get("adminCheckinDate")) || theDecision.isExpirationDateUpdated(study.get("expirationDate")))) {
        theDecision.isDecisionOutdated().success(function (response) {
          if (response.data) {
            confirmMsg = "The Expiration/Admin Check-in date in the study is different than the one on your submission.\n\n" + "Click Confirm if you want to process your submission with current values under make decision screen.\n" + "Click Cancel to go back and update your study expiration/admin check-in date under make decision screen";
          }
          var modal = self.showModal(answer, task, confirmMsg, headerTxt);
          modal.$el.css({
            overflow: 'hidden'
          });
        });
      } else {
        modal = this.showModal(answer, task, confirmMsg, headerTxt);
        modal.$el.css({
          overflow: 'hidden'
        });
      }
    },
    requestWorkflowSetAnswer: function requestWorkflowSetAnswer(answer, task) {
      var taskName = task.get('taskType').taskName,
        answerValue = answer.get('value'),
        self = this,
        submissionService = this.app.service('submission');
      function saveAnswer() {
        return task.saveAnswer(answerValue).promise().bind(self)["finally"](self.showDimmer()).tap(function () {
          self.model.trigger('updateAll');
          self.listenToOnce(self, 'refreshComplete', function () {
            if (answerValue === 'BOARD') {
              self.displayAssignReviewType();
            } else if (answerValue === 'REVIEWER') {
              self.displayAssignReviewers();
            }
          });
        });
      }
      if (taskName === 'EDIT_COMPLETE' || taskName === 'IRB_LEGACY_COMPLETE' || taskName === 'IRB_ADMIN_EDIT') {
        submissionService.navigateToFormViewer(this.model);
      } else if (taskName === 'IRB_ANALYST_ASSIGN_REVIEWERS' && this.isFullBoardReview() && !this.validateDocumentReviewerAssignments()) {
        this.createIRBReviewerAssignments().tap(function () {
          saveAnswer();
        });
      } else {
        saveAnswer();
      }
    },
    showDimmer: function showDimmer() {
      this.$el.find('.segment.details').addClass('loading');
      return _.bind(this.hideDimmer, this);
    },
    hideDimmer: function hideDimmer() {
      this.$el.find('.segment.details').removeClass('loading');
    },
    setupForm: function setupForm() {
      var self = this,
        meetings = this.getOption('meetings'),
        emptyText = emptyFormatter('N/A'),
        titleText = new UIKit.Text({
          tagName: 'div'
        }),
        statusLabel = this.statusLabel,
        studyTitleText = new UIKit.Text({
          className: 'sub header'
        }),
        analyst = new AssignmentModel({
          person: new PersonModel({
            firstName: emptyText()
          })
        }),
        changeAnalyst = new UIKit.EditableField({
          active: true,
          model: analyst,
          editable: false,
          text: 'Current Analyst:',
          input: new UIKit.Dropdown({
            collection: this.analysts,
            childBindings: {
              text: 'displayName'
            },
            search: true
          }),
          textBinding: 'displayName',
          valueBinding: 'person'
        }),
        piText = new UIKit.Text({
          name: 'pi'
        }),
        decisionText = new UIKit.Text({
          formatter: emptyText,
          model: this.model
        }),
        reviewTypeText = new UIKit.Text({
          name: 'reviewType',
          formatter: emptyText,
          model: this.model
        }),
        reviewBoardText = new UIKit.Text({
          name: 'reviewBoard',
          formatter: emptyText
        }),
        changePolicy = new UIKit.EditableField({
          active: true,
          model: new Backbone.Model(),
          submissionModel: this.model,
          editable: false,
          text: 'Policy:',
          input: new UIKit.Dropdown({
            collection: this.commonRuleOptions,
            childBindings: {
              text: 'description'
            }
          })
        }),
        meetingDate = new UIKit.Button({
          name: 'meetingDate',
          className: ''
        }),
        meetingDateText = new UIKit.Text({
          name: 'meetingDateText',
          formatter: emptyText,
          visible: false
        }),
        emptyTaskView = new UIKit.Text({
          name: 'emptyRequiredTasks',
          formatter: emptyText,
          visible: false
        }),
        taskContainer = new ListView({
          name: 'taskContainer',
          tagName: 'nav',
          attributes: {
            'aria-label': L10N.phrase('SubmissionDetails.RequiredTasks.ARIALabel')
          },
          collection: this._requiredTasks,
          childViewOptions: function childViewOptions(model) {
            if (model.get('action') === 'assignAnalyst') {
              return {
                collection: self.analysts,
                childBindings: {
                  text: 'displayName'
                }
              };
            }
            return {};
          }
        });
      this.analystField = changeAnalyst;
      this.policyField = changePolicy;
      statusLabel.model = this.model;
      statusLabel.bindings.text = 'status';
      titleText.model = this.model;
      titleText.bindings.text = 'templateType';
      decisionText.bindings.text = 'decisionStatus';
      this.statusLabel = statusLabel;
      this.titleText = titleText;
      this.studyTitleText = studyTitleText;
      this.submissionHeader.$el.addClass('ui header').css('margin-top', '1rem');
      this.submissionHeader.add(titleText).add(studyTitleText);
      this.submissionForm.addGroup({
        autoSize: false
      }).addField({
        width: 10
      }).addGroup().addField({
        width: 4,
        text: 'PI:'
      }, piText).getOption('parent').add(changeAnalyst).addField({
        width: 4,
        text: 'Decision:'
      }, decisionText).getOption('parent').add(changePolicy).getOption('parent').addGroup().addField({
        width: 4,
        text: 'Review Type:'
      }, reviewTypeText).getOption('parent').addField({
        width: 4,
        text: 'Review Board:'
      }, reviewBoardText).getOption('parent').addField({
        width: 4,
        text: 'Meeting Date:'
      }, meetingDate).add(meetingDateText).getOption('parent').getOption('parent').getOption('parent').addField({
        width: 6,
        text: 'Required Tasks:'
      }, taskContainer).add(emptyTaskView);
      this.listenTo(taskContainer, 'childview:change:value', function (view, dropdown, person) {
        if (view.model.get('action') === 'assignAnalyst') {
          app.service('workflow').requestChangeAnalyst(this.model, person)["finally"](view.render);
        }
      }).listenTo(meetings, 'sync', function () {
        this._refreshPageTasks();
        this._refreshFormText();
      });
      this.listenTo(taskContainer, 'childview:press', function (view) {
        var action = view.model.get('action');
        if (action === 'assignToMeeting') {
          this.displayAssignToMeeting();
        } else if (action === 'setupBoard') {
          this.displayAssignReviewType();
        } else if (action === 'setupReviewers') {
          this.displayAssignReviewers();
        } else if (action === 'makeDecision') {
          this.displayMakeDecision();
        } else {
          app.service('workflow').requestAction(view.model, this.model);
        }
      });
      this.attachmentsTabView = new AttachmentsTab({
        allowApplyStamps: this.getOption('allowApplyStamps'),
        canStamp: this.getOption('canStamp'),
        canDelete: this.getOption('canModifyStudy'),
        canUpload: this.getOption('canUpload'),
        uploadHandler: this.getOption('uploadHandler'),
        stampApplicationHandler: this.getOption('stampApplicationHandler'),
        showStampIndicators: true,
        tableOptions: {
          collection: this.getOption('attachments'),
          ariaLabelledby: 'attachmentsHeader'
        },
        useTableHeader: true,
        tableHeaderLevel: '3',
        hideTableHeaderFromScreens: true,
        tableHeaderText: L10N.phrase('Submissions.Details.Attachments.Title')
      });
      this.listenTo(this, 'change:allowApplyStamps', function (view, newValue) {
        view.attachmentsTabView.updateOption('allowApplyStamps', newValue);
      });
      this.steps.ordered = true;
      this.steps.collection = new BaseCollection([]);
      this.steps.collection.reset([{
        name: 'IN_DRAFT',
        title: L10N.phrase('SubmissionDetails.Steps.1.Title'),
        description: L10N.phrase('SubmissionDetails.Steps.1.Description')
      }, {
        name: 'IN_APPROVALS',
        title: L10N.phrase('SubmissionDetails.Steps.2.Title'),
        description: L10N.phrase('SubmissionDetails.Steps.2.Description')
      }, {
        name: 'PRE_REVIEW',
        title: L10N.phrase('SubmissionDetails.Steps.3.Title'),
        description: L10N.phrase('SubmissionDetails.Steps.3.Description')
      }, {
        name: 'UNDER_REVIEW',
        title: L10N.phrase('SubmissionDetails.Steps.4.Title'),
        description: L10N.phrase('SubmissionDetails.Steps.4.Description')
      }]);
      this.policyField.setPolicyField = function () {
        var self = this;
        var submissionModel = this.getOption('submissionModel');
        var setSelectedPolicy = function setSelectedPolicy() {
          var policyValue = submissionModel.get('commonRulePolicy');
          var selectedValue;
          if (policyValue) {
            selectedValue = self.input.collection.findWhere({
              name: policyValue
            });
            if (selectedValue) {
              self.originalPolicy = policyValue;
              self.input.value = selectedValue;
              self.textView.text = selectedValue.get('description');
            }
          }
        };
        this.textView.text = 'N/A';
        if (!this.input.collection.fetched) {
          this.input.collection.on('sync', function () {
            setSelectedPolicy();
          });
        } else {
          setSelectedPolicy();
        }
      };
    },
    displayAssignToMeeting: function displayAssignToMeeting() {
      var meetings = this.meetings,
        overlay = this.getOption('overlay'),
        app = this.app;
      new MeetingSubmissionController(app, overlay.content, this.getOption('state')).start();
      _.defer(function () {
        overlay.active = true;
      });
      overlay.once('hidden', function () {
        meetings.fetch();
        overlay.content.empty();
      });
    },
    displayAssignReviewType: function displayAssignReviewType() {
      var assignmentTypes = AssignmentTypeModel.all(),
        boards = BoardModel.all({
          active: true
        }),
        app = this.app;
      Promise.join(assignmentTypes.fetch(), boards.fetch()).bind(this).tap(function () {
        var contentView = new AssignReviewTypeOverlay({
            task: this.getCurrentTask(),
            submission: this.model,
            assignments: this.assignments,
            assignmentTypes: assignmentTypes,
            boards: boards,
            decisions: this.decisions
          }),
          self = this;
        app.overlay.content.show(contentView);
        app.overlay.buttonType = 'save';
        app.overlay.cancelable = true;
        app.overlay.header.text = 'Choose a Review Type and Board';
        if (this.app.service('submission').isClosure(this.model)) {
          app.overlay.header.text = 'Choose a Review Board';
        }
        app.overlay.active = true;
        contentView.listenTo(app.overlay, 'save', function () {
          var assignments = contentView.getAssignments(),
            errors = self.validateBoardObjAssignments(assignments);
          contentView.form.errors.reset([]);
          if (errors.length) {
            app.overlay.active = true;
            contentView.form.errors.reset(errors);
          } else {
            self.createNewPathwayAssignments(assignments);
          }
        }).listenTo(app.overlay, 'hidden', function () {
          contentView.destroy();
        });
      })["finally"](this.showDimmer());
    },
    displayAssignReviewers: function displayAssignReviewers() {
      var boardAssignment = this.assignments.getByAssignmentTypeProp('IRB_BOARD', 'description').models[0],
        board = boardAssignment ? new BoardModel({
          id: boardAssignment.get('group').get('id')
        }) : null,
        members = new BaseCollection(),
        app = this.app;
      function fetchBoardMembers() {
        if (board) {
          members = board.members();
          return members.fetch();
        }
      }
      Promise.resolve(fetchBoardMembers()).bind(this).tap(function () {
        var boardMembers = this.filterBoardMembersConflicts(members),
          contentView = new AssignReviewerOverlay({
            assignments: this.assignments,
            analysts: this.analysts,
            boardMembers: boardMembers,
            decisions: this.decisions,
            overlay: app.overlay
          }),
          self = this;
        app.overlay.content.show(contentView);
        app.overlay.buttonType = 'save';
        app.overlay.cancelable = true;
        app.overlay.header.text = 'Choose Reviewers';
        app.overlay.active = true;
        contentView.listenTo(app.overlay, 'save', function () {
          var assignments = contentView.getAssignments(),
            isValid = contentView.validateForm();
          if (!isValid) {
            app.overlay.active = true;
          } else {
            self.createNewReviewerAssignments(assignments);
          }
        }).listenTo(app.overlay, 'hidden', function () {
          contentView.destroy();
        });
      })["finally"](this.showDimmer());
    },
    showDecisionDetails: function showDecisionDetails(decision) {
      var decisionService = this.app.service('decision');
      if (decisionService.isResponsiblePerson(decision)) {
        this.displayMakeDecision(decision);
      } else {
        this.displayHistoricalDecision(decision);
      }
    },
    displayMakeDecision: function displayMakeDecision(decision) {
      var theDecision = decision || this.getResponsibleDecision(this.useParentDecision()),
        self = this;
      theDecision.isDecisionOutdated().success(function (response) {
        theDecision.study = self.options.study;
        theDecision.isOutdated = response.data;
        self.app.request('decisionDetailsOverlay', {
          model: theDecision
        });
        self.decisions.fetch().promise().tap(function () {
          self._refreshChildDecisions();
        })["finally"](self.showDimmer());
        theDecision.once('sync', function () {
          self.decisions.fetch().promise().tap(function () {
            self._refreshPageTasks();
            self._refreshActionBtns();
            self._refreshChildDecisions();
          })["finally"](self.showDimmer());
        });
      });
    },
    displayHistoricalDecision: function displayHistoricalDecision(decision) {
      var self = this;
      var decisionService = self.app.service('decision');
      var isEditable = decisionService.isDecisionEditable(decision) || decisionService.isSubDecisionEditable(decision);
      decision.study = self.options.study;
      if (isEditable) {
        decision.isDecisionOutdated().success(function (response) {
          decision.isOutdated = response.data;
          displayHistoricalDecision(decision, isEditable);
        });
      } else {
        displayHistoricalDecision(decision, isEditable);
      }
      function displayHistoricalDecision(decision, isEditable) {
        this.app.request('decisionDetailsOverlay', {
          model: decision
        }).once('hidden', function () {
          if (isEditable) {
            self.decisions.fetch().promise().tap(function () {
              self._refreshPageTasks();
              self._refreshActionBtns();
              self._refreshChildDecisions();
            })["finally"](self.showDimmer());
          }
        });
      }
    },
    filterBoardMembersConflicts: function filterBoardMembersConflicts(members) {
      var assignmentService = this.app.service('assignment');
      var conflicts = assignmentService.getConflictOfInterest(this.assignments);
      members.each(function (m) {
        if (_.findWhere(conflicts, {
          id: m.get('person').id
        })) {
          m.set('conflictOfInterest', 'Conflict');
        }
      });
      return members;
    },
    validateDocumentBoardAssignments: function validateDocumentBoardAssignments() {
      var reviewType = this.assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0],
        isFullExpedited = this.assignments.getByAssignmentTypeProp('IRB_IS_FULL_EXPEDITED', 'description').models[0],
        reviewerType = this.assignments.getByAssignmentTypeProp('IRB_EXEMPT_TYPE', 'description').models[0] || this.assignments.getByAssignmentTypeProp('IRB_FULL_EXPEDITED_REVIEW_TYPE', 'description').models[0],
        board = this.assignments.getByAssignmentTypeProp('IRB_BOARD', 'description').models[0],
        filteredAssignments = {};
      filteredAssignments.reviewType = reviewType && reviewType.get('value');
      filteredAssignments.isFullExpedited = isFullExpedited && isFullExpedited.get('value');
      filteredAssignments.reviewerType = reviewerType && reviewerType.get('value');
      filteredAssignments.board = board;
      return this.validateBoardAssignments(filteredAssignments).length === 0;
    },
    validateBoardObjAssignments: function validateBoardObjAssignments(assignments) {
      var propertyAssignmentObjs = assignments.property,
        groupAssignmentObjs = assignments.group,
        validate = {};
      validate.reviewType = _.findWhere(propertyAssignmentObjs, {
        type: 'IRB_REVIEW_TYPE'
      }).value;
      validate.isFullExpedited = _.findWhere(propertyAssignmentObjs, {
        type: 'IRB_IS_FULL_EXPEDITED'
      }).value;
      validate.reviewerType = _.findWhere(propertyAssignmentObjs, {
        type: 'IRB_EXEMPT_TYPE'
      }).value || _.findWhere(propertyAssignmentObjs, {
        type: 'IRB_FULL_EXPEDITED_REVIEW_TYPE'
      }).value;
      validate.board = _.findWhere(groupAssignmentObjs, {
        type: 'IRB_BOARD'
      }).group;
      return this.validateBoardAssignments(validate);
    },
    validateDocumentReviewerAssignments: function validateDocumentReviewerAssignments() {
      var assignments = this.getOption('assignments'),
        reviewers = {
          primaryReviewer: assignments.getByAssignmentTypeProp('IRB_REVIEWER_PRIMARY', 'description').models[0],
          fullExpReviewer: assignments.getByAssignmentTypeProp('IRB_FULL_EXPEDITED_REVIEWER', 'description').models[0],
          reviewers: assignments.getByAssignmentTypeDescription('IRB_REVIEWER').models
        },
        assignmentService = this.app.service('assignment');
      return assignmentService.validateReviewerAssignments(assignments, reviewers).length === 0;
    },
    validateBoardAssignments: function validateBoardAssignments(assignments) {
      var reviewType = assignments.reviewType,
        isFullExpedited = assignments.isFullExpedited,
        reviewerType = assignments.reviewerType,
        board = assignments.board,
        submissionService = this.app.service('submission'),
        reviewerTypeError = {
          field: 'reviewerType',
          error: 'Reviewer Type is required.'
        },
        boardError = {
          field: 'board',
          error: 'Board is required.'
        },
        overseeingBoardError = {
          field: 'overseeingBoard',
          error: 'Board is required.'
        },
        errors = [];
      if (this.app.service('submission').isClosure(this.model)) {
        if (!board) {
          errors.push(overseeingBoardError);
        }
        return errors;
      }
      switch (reviewType) {
        case 'FULL':
          if (isFullExpedited === 'true') {
            if (!reviewerType) {
              errors.push(reviewerTypeError);
            } else if (reviewerType === 'IRB_BOARD') {
              if (!board) {
                errors.push(boardError);
              }
            }
          } else if (!board) {
            errors.push(boardError);
          }
          break;
        case 'EXPEDITED':
        case 'LIMITED':
        case 'ADMINISTRATIVE':
          if (!board) {
            errors.push(boardError);
          }
          break;
        case 'EXEMPT':
          if (!reviewerType) {
            errors.push(reviewerTypeError);
          } else if (reviewerType === 'IRB_BOARD') {
            if (!board) {
              errors.push(boardError);
            }
          } else if (reviewerType === 'IRB_ANALYST') {
            if (!board) {
              errors.push(overseeingBoardError);
            }
          }
          break;
        default:
          errors.push({
            field: 'reviewType',
            error: 'Review type is required.'
          });
          break;
      }
      return errors;
    },
    createNewReviewerAssignments: function createNewReviewerAssignments(assignments) {
      var assignmentService = this.app.service('assignment');
      assignmentService.newPersonAssignments(this.model.get('id'), assignments).bind(this).tap(function () {
        return this.assignments.fetch();
      }).tap(function () {
        this._refreshPageAssignments();
        this._refreshPageTasks();
      })["finally"](this.showDimmer());
    },
    createIRBReviewerAssignments: function createIRBReviewerAssignments() {
      var assignments = this.getOption('assignments'),
        boardAssignment = this.assignments.getByAssignmentTypeProp('IRB_BOARD', 'description').models[0],
        board = boardAssignment ? new BoardModel({
          id: boardAssignment.get('group').get('id')
        }) : null,
        members = new BaseCollection();
      var assignmentService = this.app.service('assignment');
      function fetchBoardMembers() {
        if (board) {
          members = board.members();
          return members.fetch();
        }
      }
      return Promise.resolve(fetchBoardMembers()).bind(this).then(function () {
        members = this.filterBoardMembersConflicts(members).filter(function (b) {
          return !b.get('conflictOfInterest');
        });
        if (members.length) {
          var newAssignments = _.map(members, function (m) {
            return {
              type: 'IRB_REVIEWER',
              group: board,
              person: m.get('person')
            };
          });
          return assignmentService.newPersonAssignments(this.model.get('id'), newAssignments);
        }
      })["finally"](this.showDimmer());
    },
    createNewPathwayAssignments: function createNewPathwayAssignments(assignments) {
      var propertyAssignmentObjs = assignments.property,
        groupAssignmentObjs = assignments.group,
        oldAssignments = this.assignments,
        oldReviewType = oldAssignments.findWhere({
          assignmentTypeDescription: 'IRB_REVIEW_TYPE'
        }),
        oldIsFullExpedited = oldAssignments.findWhere({
          assignmentTypeDescription: 'IRB_IS_FULL_EXPEDITED'
        }),
        documentId = this.model.get('id');
      var assignmentService = this.app.service('assignment');
      assignmentService.newPropertyAssignments(documentId, propertyAssignmentObjs).bind(this).tap(function () {
        return assignmentService.newGroupAssignments(documentId, groupAssignmentObjs);
      }).tap(function () {
        var newReviewType = _.find(propertyAssignmentObjs, function (a) {
            return a.assignmentType.get('description') === 'IRB_REVIEW_TYPE';
          }),
          newIsFullExpedited = _.find(propertyAssignmentObjs, function (a) {
            return a.assignmentType.get('description') === 'IRB_IS_FULL_EXPEDITED';
          });
        if (oldReviewType && oldIsFullExpedited && (newReviewType.value !== oldReviewType.get('value') || newIsFullExpedited.value !== oldIsFullExpedited.get('value'))) {
          return this.clearReviewerAssignments();
        }
      }).tap(function () {
        return this.assignments.fetch();
      }).tap(function () {
        this._refreshPageAssignments();
        this._refreshPageTasks();
      })["finally"](this.showDimmer());
    },
    clearReviewerAssignments: function clearReviewerAssignments() {
      var assignments = [{
        type: 'IRB_FULL_EXPEDITED_REVIEWER',
        person: null,
        group: null
      }, {
        type: 'IRB_REVIEWER_PRIMARY',
        person: null,
        group: null
      }, {
        type: 'IRB_REVIEWER_SECONDARY',
        person: null,
        group: null
      }, {
        type: 'IRB_REVIEWER',
        person: null,
        group: null
      }];
      return this.app.service('assignment').newPersonAssignments(this.model.get('id'), assignments);
    },
    _refreshWorkflowProgression: function _refreshWorkflowProgression() {
      var steps = this.steps.collection.models,
        status = this.model.get('status'),
        activeSet = false;
      for (var s = 0, numOfSteps = steps.length; s < numOfSteps; s++) {
        steps[s].set('active', false);
        steps[s].set('completed', false);
        steps[s].set('disabled', false);
        if (!activeSet) {
          if (DocumentModel[steps[s].get('name')].indexOf(status) > -1) {
            activeSet = true;
            steps[s].set('active', true);
          } else {
            steps[s].set('completed', true);
          }
        } else {
          steps[s].set('disabled', true);
        }
      }
    },
    _refreshChildDecisions: function _refreshChildDecisions() {
      var self = this,
        childDecisions = new BaseCollection([]),
        openDecisions = this.openDecisions,
        canPromoteDecisions = this.canPromoteDecisions();
      function setupDecisionDigestRowActions(column) {
        return {
          collection: new BaseCollection([{
            text: 'View',
            action: 'decision'
          }, {
            text: 'Promote',
            action: 'select',
            disabled: !canPromoteDecisions
          }]),
          childBindings: {
            text: 'text',
            icon: 'icon',
            link: 'link',
            disabled: 'disabled'
          }
        };
      }
      var DECISION_DIGEST_COLUMNS = [{
        childView: TableEllipsis,
        childViewOptions: setupDecisionDigestRowActions,
        sortable: false,
        collapsing: true
      }, {
        text: 'Name',
        data: 'responsiblePerson',
        formatter: function formatter(p) {
          return p.get('displayName');
        }
      }, {
        text: 'Role',
        data: 'responsiblePerson',
        formatter: _.bind(this.getAssignmentDisplayName, this)
      }, {
        text: 'Decision',
        data: 'decisionType.description',
        formatter: emptyFormatter('Undecided')
      }, {
        text: 'Finalized',
        data: 'finalizedDate',
        formatter: _.bind(this.checkFinalizedStatus, this)
      }];
      this.decisionDigestTable.columns.reset(DECISION_DIGEST_COLUMNS);
      if (openDecisions.length) {
        childDecisions = openDecisions.models[0].get('children');
      }
      this.decisionDigestTable.collection = childDecisions;
      if (!!childDecisions.length) {
        this.decisionDigestTable.value = childDecisions.at(0);
      }
    },
    _refreshPdfList: function _refreshPdfList() {
      var list = [{
        text: 'Submission',
        type: 'submission'
      }];
      if (this.app.request('check:authority', 'PERM_VIEW_ALL_CHECKLISTS')) {
        list.push({
          text: 'All Checklists',
          link: ChecklistModel.allPDFLink(this.model.id),
          target: '_blank'
        });
      }
      list = list.concat(this.historicalChecklists.map(function (hc) {
        var name = hc.get('responsiblePersons').pluck('displayName').join(', ');
        var text = hc.get('templateType') + '<br><small>' + name + '</small>';
        return {
          text: new Handlebars.SafeString(text),
          link: ChecklistModel.onePDFLink(hc.id),
          target: '_blank'
        };
      }));
      this.checklistDropdownCollection.set(list);
    },
    checkFinalizedStatus: function checkFinalizedStatus(finalizedDate) {
      var icon = $('<i/>');
      if (finalizedDate) {
        icon.addClass('green checkmark icon');
      } else {
        icon.addClass('minus icon');
      }
      return new Handlebars.SafeString(icon.get(0).outerHTML);
    },
    getPersonsAssignment: function getPersonsAssignment(person) {
      return this.assignments.filter(function (a) {
        return a.get('personId') === person.get('id');
      })[0];
    },
    getAssignmentDisplayName: function getAssignmentDisplayName(person) {
      var assignment = this.getPersonsAssignment(person);
      return assignment ? assignment.get('assignmentType').get('displayName') : '';
    },
    onDecisionDigestRowAction: function onDecisionDigestRowAction(row, child, actionModel) {
      var decision = row.model,
        action = actionModel.get('action'),
        self = this;
      if (action === 'select') {
        this.app.request('modal', {
          approveBtn: {
            text: 'Promote',
            color: 'red'
          },
          denyBtn: {
            text: 'Cancel'
          },
          content: 'Are you sure you want to promote this decision? Continuing will discard the current submission decision.',
          header: 'Warning',
          type: 'CONFIRM'
        }).on('confirm', function () {
          decision.promote().promise().tap(function () {
            self.model.trigger('updateAll');
          });
        });
      } else if (action === 'decision') {
        this.showDecisionDetails(decision);
      }
    },
    isPartOfResearchTeam: function isPartOfResearchTeam() {
      var researchTeam = this.studyAssignments.pluck('person'),
        currentUserId = this.app.user.person.getId();
      return !!_.find(researchTeam, function (p) {
        return (p && p.get('id')) === currentUserId;
      });
    },
    hasViewMeetingPermission: function hasViewMeetingPermission() {
      var currentPerson = this.app.user.person;
      return currentPerson.hasPermission('VIEW_MEETING') && !this.isPartOfResearchTeam();
    },
    setupTables: function setupTables() {
      var submissionService = this.app.service('submission');
      this.decisionDigestTable = new UIKit.Table();
      this.decisionDigestTable.compact = true;
      this.decisionDigestTable.padded = false;
      this.decisionDigestTable.sortable = false;
      this.decisionDigestTable.selectable = true;
      this.decisionDigestTable.selection = 'single';
      this.listenTo(this.decisionDigestTable, 'row:double:press', function (row) {
        this.showDecisionDetails(row.model);
      });
      this.listenTo(this.decisionDigestTable, 'row:before:add:child', function (row, child) {
        if (child instanceof TableEllipsis) {
          child.on('action', _.bind(this.onDecisionDigestRowAction, this, row));
        }
      });
      this.decisionTableHeader = new UIKit.Header({
        tagName: 'h3',
        className: UIKit.Header.prototype.className + ' accessibility-text',
        text: L10N.phrase('Submissions.Details.Decisions.Title')
      });
      this.decisionHistoryTable = new UIKit.Table();
      this.decisionHistoryTable.columns.add(DECISION_HISTORY_COLUMNS);
      this.decisionHistoryTable.link = true;
      this.decisionHistoryTable.compact = true;
      this.decisionHistoryTable.padded = false;
      this.decisionHistoryTable.sortable = false;
      this.decisionHistoryTable.selectable = true;
      this.decisionHistoryTable.collection = this.decisions;
      this.listenTo(this.decisionHistoryTable, 'row:press', function (row) {
        this.displayHistoricalDecision(row.model);
      });
      this.lettersTableHeader = new UIKit.Header({
        tagName: 'h3',
        className: UIKit.Header.prototype.className + ' accessibility-text',
        text: L10N.phrase('Submissions.Details.Letters.Title')
      });
      this.lettersTable = new UIKit.Table();
      this.lettersTable.columns.add(LETTERS_COLUMNS);
      this.lettersTable.compact = true;
      this.lettersTable.link = true;
      this.lettersTable.padded = false;
      this.lettersTable.sortable = false;
      this.lettersTable.selectable = true;
      this.lettersTable.collection = this.letters;
      this.listenTo(this.lettersTable, 'row:press', function (row) {
        var letter = row.model,
          popup = this.app.request('pdf:popup');
        if (letter.get('dateSent')) {
          submissionService.createLetterPDF(letter.get('contentSent'), popup);
        } else {
          letter.replaceText(this.model.get('id')).promise().bind(this)["finally"](this.showDimmer()).tap(function (response) {
            submissionService.createLetterPDF(response.data, popup);
          });
        }
      });
      this.meetingsTableHeader = new UIKit.Header({
        tagName: 'h3',
        className: UIKit.Header.prototype.className + ' accessibility-text',
        text: L10N.phrase('Submissions.Details.Meetings.Title')
      });
      this.meetingsTable = new UIKit.Table();
      this.meetingsTable.compact = true;
      this.meetingsTable.padded = false;
      this.meetingsTable.sortable = false;
      this.meetingsTable.collection = this.meetings;
      var submission = this.model;
      this.listenTo(this.meetingsTable, 'row:press', function (row) {
        SubmissionModule.navigateToMeetingDetail(row.model, submission);
      });
    },
    setupTabs: function setupTabs() {
      var tabs = this.tabs,
        approvalsContent = new SubmissionApprovalsTab({
          collection: this.approvals
        }),
        taskHistoryContent = new PageListView({
          header: false,
          search: false,
          useTableHeader: true,
          tableHeaderText: L10N.phrase('Submissions.Details.TaskHistory.Title')
        }),
        decisionsContent = new UIKit.Container(),
        lettersContent = new UIKit.Container(),
        meetingsContent = new UIKit.Container();
      tabs.attached = '';
      tabs.tabListAriaLabel = L10N.phrase('Submissions.Details.Tabs.ARIALabel');
      tabs.add('Approvals', approvalsContent);
      tabs.add('Task History', taskHistoryContent);
      tabs.add('Letters', lettersContent);
      tabs.add('Meetings', meetingsContent);
      tabs.add('Decisions', decisionsContent);
      tabs.add('Attachments', this.attachmentsTabView);
      tabs.each(function (view) {
        view.attached = '';
        view.$el.addClass('basic fitted');
      });
      decisionsContent.add(this.decisionTableHeader);
      decisionsContent.add(new UIKit.Text({
        tagName: 'h4',
        className: 'ui header tab-submissions-decisions ',
        text: L10N.phrase('Submissions.Details.Decisions.Digest.Title')
      }));
      decisionsContent.add(this.decisionDigestTable);
      decisionsContent.add(new UIKit.Text({
        tagName: 'h4',
        className: 'ui header tab-submissions-decisions',
        text: L10N.phrase('Submissions.Details.Decisions.History.Title')
      }));
      decisionsContent.add(this.decisionHistoryTable);
      lettersContent.add(this.lettersTableHeader);
      lettersContent.add(this.lettersTable);
      meetingsContent.add(this.meetingsTableHeader);
      meetingsContent.add(this.meetingsTable);
      taskHistoryContent.setupCollection(this.tasksHistory, {
        autoFetch: true
      }).setupLoading().setupPaginate().setupPageSizes().setupColumns(TASKS_HISTORY_COLUMNS);
      taskHistoryContent.table.compact = true;
      taskHistoryContent.table.padded = false;
      taskHistoryContent.table.sortable = false;
      taskHistoryContent.table.basic = false;
      taskHistoryContent.table.$el.css({
        border: '0px'
      });
    },
    isAnalyst: function isAnalyst() {
      var analyst = this.assignments.getByAssignmentTypeProp('IRB_ANALYST', 'description').models[0];
      if (analyst) {
        return analyst.get('person').get('id') === this.app.user.personId;
      }
      return false;
    },
    isFullBoardReview: function isFullBoardReview() {
      var assignments = this.getOption('assignments'),
        reviewType = assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0].get('value'),
        isFullExpedited = assignments.getByAssignmentTypeProp('IRB_IS_FULL_EXPEDITED', 'description').models[0].get('value');
      return reviewType === 'FULL' && isFullExpedited === 'false';
    },
    canPromoteDecisions: function canPromoteDecisions() {
      var openDecision = this.openDecisions.models[0],
        childDecisions = openDecision ? openDecision.get('children') : [],
        hasPrimaryReviewer = this.hasAssignment('IRB_REVIEWER_PRIMARY'),
        allFinalized = _.every(childDecisions.models, function (d) {
          return !!d.get('finalizedDate');
        });
      return !hasPrimaryReviewer && this.isAnalyst() && allFinalized;
    },
    hasAssignment: function hasAssignment(value) {
      return !!this.assignments.getByAssignmentTypeProp(value, 'description').length;
    },
    hasOpenLetters: function hasOpenLetters() {
      var lastReadOnlyDate = this.model.get('lastReadOnlyDate');
      return !!this.letters.filter(function (letter) {
        return letter.get('activityDate') >= lastReadOnlyDate && !letter.get('dateSent');
      }).length;
    },
    hasOpenMeetings: function hasOpenMeetings() {
      var now = new Date().getTime(),
        meetings = this.meetings;
      if (!this.decisions.length) {
        return !!meetings.length;
      } else {
        var lastDecisionDate = this.decisions.at(0).get('finalizedDate');
        if (!meetings.length) {
          return false;
        }
        for (var m = 0, meetingsLen = meetings.length; m < meetingsLen; m++) {
          if (meetings.at(m).get('startDate') > lastDecisionDate) {
            return true;
          }
        }
      }
    },
    hasResponsibleDecision: function hasResponsibleDecision(outermost) {
      var responsibleDecision = this.getResponsibleDecision(outermost);
      if (responsibleDecision && responsibleDecision.get('decisionType')) {
        return true;
      }
      return false;
    },
    getResponsibleDecision: function getResponsibleDecision(outermost) {
      var personId = this.getOption('app').user.personId,
        active = this.getOption('openDecisions').models[0],
        responsibleDecision = null;
      function recurseDecision(root) {
        var children = root.get('children');
        if (root.get('responsiblePerson').get('id') === personId) {
          responsibleDecision = root;
          if (outermost) {
            return;
          }
        }
        if (children && children.length) {
          for (var i = 0, len = children.models.length; i < len; i++) {
            recurseDecision(children.models[i]);
          }
        }
      }
      if (active) {
        recurseDecision(active);
      }
      return responsibleDecision;
    },
    useParentDecision: function useParentDecision() {
      var task = this.getCurrentTask();
      if (task) {
        var taskName = task.get('taskType').taskName;
        switch (taskName) {
          case 'IRB_FULL_REVIEW_COMPLETE':
          case 'IRB_FULL_EXPEDITED_POST_REVIEW':
          case 'EXPEDITED_REVIEW_COMPLETE':
          case 'LIMITED_IRB_REVIEW_COMPLETE':
          case 'ADMINISTRATIVE_REVIEW_COMPLETE':
          case 'IRB_EXEMPT_POST_REVIEW':
            return true;
          case 'IRB_FULL_EXPEDITED_REVIEW':
          case 'IRB_EXEMPT_REVIEW_COMPLETE':
          case 'IRB_EXPEDITED_PRIMARY_REVIEW':
          case 'IRB_MEMBER_EXPEDITED_REVIEW':
          case 'LIMITED_IRB_PRIMARY_REVIEW':
          case 'LIMITED_IRB_MEMBER_REVIEW':
          case 'ADMINISTRATIVE_PRIMARY_REVIEW':
          case 'IRB_MEMBER_ADMINISTRATIVE_REVIEW':
            return false;
        }
      }
      return false;
    },
    isTaskCompleted: function isTaskCompleted(task) {
      var action = task.get('action');
      switch (action) {
        case 'assignPrincipalInvestigator':
          return this.hasAssignment('PRINCIPAL_INVESTIGATOR');
        case 'assignPrimaryContact':
          return this.hasAssignment('PRIMARY_CONTACT');
        case 'assignAnalyst':
          return this.hasAssignment('IRB_ANALYST');
        case 'setupBoard':
          return this.validateDocumentBoardAssignments();
        case 'setupReviewers':
          return this.validateDocumentReviewerAssignments();
        case 'manageLetters':
          return this.hasOpenLetters();
        case 'assignToMeeting':
          return this.hasOpenMeetings();
        case 'makeDecision':
          return this.hasResponsibleDecision(this.useParentDecision());
      }
      return false;
    }
  });
  module.exports = SubmissionDetailView;
});

